import documentsApi from "../../api/documentsApi";
import documentTypeApi from "../../api/documentsApi";

const state = {
    documents: [],
    document: {},
    metadataValues: []

}

const actions = {
    getDocumentscount({ commit }) {
        return new Promise((resolve, reject) => {
            documentTypeApi.countDocument().then((response) => {
                if (response.status == 200) {
                    resolve(response)
                    commit("SET_DOCUMENTS", response.data)
                }
                reject(response)
            }).catch((error) => {
                reject(error)
            })
        })
    },
    getDocumentsSize({ commit }) {
        return new Promise((resolve, reject) => {
            documentTypeApi.documentsSize().then((response) => {
                if (response.status == 200) {
                    resolve(response)
                    commit("SET_DOCUMENTS", response.data)
                }
                reject(response)
            }).catch((error) => {
                reject(error)
            })
        })
    },
    getDocumentById({ commit }, id) {
        return new Promise((resolve, reject) => {
            documentTypeApi.getDocumentById(id).then((response) => {
                if (response.status == 200) {
                    resolve(response)
                    commit("SET_DOCUMENT", response.data)
                }
                reject(response)
            }).catch((error) => {
                reject(error)
            })
        })
    },
    getDocumentPath({ commit }, id) {
        return new Promise((resolve, reject) => {
            documentsApi.getDocumentPath(id).then((response) => {
                if (response.status == 200) {
                    resolve(response)
                    commit();
                }
                reject(response)
            }).catch((error) => {
                reject(error)
            })
        })
    },
    getListdocuments({ commit }) {
        return new Promise((resolve, reject) => {
            documentTypeApi.listdocuments().then((response) => {
                if (response.status == 200) {
                    resolve(response)
                    commit("SET_DOCUMENTS", response.data)
                }
                reject(response)
            }).catch((error) => {
                reject(error)
            })
        })
    },
    documentMetadata({commit}, docId) {
        return new Promise((resolve, reject) => {
            documentsApi.documentMetadata(docId)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                    commit("SET_DOCUMENT_METADATA", response.data.MetadataValues);
                    commit("SET_DOCUMENT", response.data.DocumentType);
                }
                reject(response);
            })
            .catch((error) => {
                reject(error);
            });
        })
    },
    modifyDocumentType({commit}, data) {
        return new Promise((resolve, reject) => {
            documentsApi.modifyDocumentType(data)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response);
                    commit();
                }
                reject(response);
            })
            .catch((error) => {
                reject(error);
            })
        })
    }
}
const mutations = {
    SET_DOCUMENTS: (state, documents) => (state.documents) = documents,
    SET_DOCUMENT_METADATA: (state, metadataValues) => (state.metadataValues) = metadataValues,
    SET_DOCUMENT: (state, document) => (state.document) = document
}
export default { state, actions, mutations };